import { createStore } from 'zustand';

import { LoginOriginEnum, VerificationCodeFlow } from '@/types/enums/analytics/login/login-analytics.enum';

export type PendingSignupState = {
  token: string;
  maskedEmail: string;
  returnUrl?: string;
  origin?: LoginOriginEnum;
  flow?: VerificationCodeFlow;
};

export const pendingSignupStore = createStore<PendingSignupState>(() => {
  return {
    token: '',
    maskedEmail: '',
  };
});

export const setPendingSignup = (pendingSignup: PendingSignupState) => {
  pendingSignupStore.setState(pendingSignup, true);
};

export const startPendingSignup = (origin?: LoginOriginEnum) => {
  pendingSignupStore.setState({ ...pendingSignupStore.getInitialState(), origin }, true);
};

export const replacePendingSignupToken = (token: string) => {
  pendingSignupStore.setState({ token });
};

export const clearPendingSignup = () => {
  pendingSignupStore.setState(pendingSignupStore.getInitialState(), true);
};
